import config from '@/config';
import router from '@/router';
import { useUserStore } from '@/stores/user';

export const orderPdfRoute = (id: string) => {
  const { hasFeatureFlag } = useUserStore();

  if (hasFeatureFlag('compliant-register')) {
    router.push({ name: 'sale', params: { id } });
  } else {
    window.open(`${config.backendUrl}/orders/${id}.pdf`, '_blank');
  }
};

export const orderPdfIcon = () => {
  const { hasFeatureFlag } = useUserStore();

  if (hasFeatureFlag('compliant-register')) {
    return 'view';
  }

  return 'pdf';
};
